import React                   from 'react';
import { Link }                from 'react-router-dom';
import Alert                   from '../../shared/alert';
import Back                    from '../../shared/back';
import { ArrowLeftCircleIcon } from '../../shared/icons/icons.jsx';
import LoaderButton            from '../../shared/loader-button/loader-button.jsx';
import PasswordHelper          from '../../shared/password-helper-input/password-helper.jsx';
import LocaleString            from '../../shared/locale-string';
import describedByString       from '../../../utils/describedby-string';

import './activation.scss';

class Activation extends React.Component {
    resetFocus = false;
    state = {
        username: '',
        password: '',
        characteristics: {}
    };

    UNSAFE_componentWillMount() {//eslint-disable-line
        this.props.dismissAllErrors();
    }

    componentWillUnmount() {
        this.props.preActivationLoginAttempt( false, '' );
    }

    UNSAFE_componentWillUpdate( nextProps ) {//eslint-disable-line
        const {
            done,
            routeTo,
            errors: {
                length: newErrorsLength
            }
        } = nextProps;

        const oldErrorsLength = this.props.errors.length;
        this.resetFocus = ( newErrorsLength > oldErrorsLength );

        if ( done ) {
            routeTo( '/home' );
        }
    }

    componentDidUpdate() {
        // on error, move focus to first input
        if ( this.resetFocus ) {
            document.getElementById( 'username' ).focus();
            this.resetFocus = false;
        }
    }

    onActivateSubmit = () => {
        const characteristics = [];

        const {
            activationFields,
            dismissAllErrors
        } = this.props;

        const {
            username,
            password
        } = this.state;

        activationFields.forEach( field => {
            // Service that sends characteristics sends data in a different format than the service
            // that receives the characteristic data.
            const { characteristic, id } = field;
            const newCharacteristic = { ...characteristic };

            // If the field is the hire date, strip any non digit characters from the value. BE stores the dates as
            // 8 digit strings with no slashes or dashes
            const characteristicValue = this.state.characteristics[ field.characteristic.code ];
            if ( newCharacteristic.code === 'hiredate' ) {
                newCharacteristic.label = characteristicValue.replace( /\D/g, '' ).length > 0 ? characteristicValue.replace( /\D/g, '' ) : characteristicValue;
            } else {
                newCharacteristic.label = characteristicValue;
            }

            newCharacteristic.code = id.toString();
            characteristics.push( newCharacteristic );
        } );

        dismissAllErrors();

        this.props.activate( username, password, characteristics );
    };

    handleField = event => {
        const { name, value } = event.target;

        if ( name === 'username' || name === 'password' ) {
            this.setState( { [ name ]: value } );
        } else {
            const characteristics = { ...this.state.characteristics };
            characteristics[ name ] = value;
            this.setState( { characteristics } );
        }
    };

    validateFields = () => {
        const { activationFields } = this.props;

        const {
            username,
            password
        } = this.state;

        if ( !username.length || !password.length ) {
            return false;
        }

        return activationFields.every( field => {
            return this.state.characteristics[ field.characteristic.code ] && this.state.characteristics[ field.characteristic.code ].length > 0;
        } );
    };

    checkEnter = event => {
        const enterPressed = event.charCode === 13;

        if ( enterPressed && this.validateFields() ) {
            this.onActivateSubmit();
        }
    };

    render() {
        const {
            activating,
            activationFields,
            done,
            locale,
            passwordRules,
            passwordLabels,
            passwordRequirements,
            errors,
            dismissError,
            preActivationLoginAttemptFlag,
            warningMessage,
            hireDatePlaceholder,
            birthDatePlaceholder
        } = this.props;

        const {
            username,
            password
        } = this.state;

       const describedByErrors = describedByString( errors, 'error' );

        return (
            <section className="activation">
                <div className="narrow-form">

                    <div className="title" >
                        <Back className="back brand-hover">
                            <ArrowLeftCircleIcon />
                        </Back>
                        <h1><LocaleString code="activation.form.headerLabel" /></h1>
                    </div>

                    {
                        preActivationLoginAttemptFlag &&
                        <Alert type={ 'warning' }>
                            <p>{ warningMessage }</p>
                        </Alert>
                    }

                    <div aria-describedby={ describedByErrors }>
                        <label htmlFor="username">
                            <LocaleString code="common.input.usernameLabel" />
                        </label>
                        <input
                            id="username"
                            type="text"
                            name="username"
                            required={ true }
                            value={ username }
                            onChange={ this.handleField }
                            onKeyPress={ this.checkEnter }
                        />

                        <PasswordHelper
                            id="password"
                            label={ <LocaleString code="login.input.passwordLabel" /> }
                            srRulesTitle={ <LocaleString code="common.input.srPwdRulesTitle" /> }
                            meetsCriteriaMsg={ <LocaleString code="common.input.srPwdCriteriaMessage" /> }
                            name= "password"
                            value= { password }
                            onChange={ this.handleField }
                            passwordRules={ passwordRules }
                            passwordLabels={ passwordLabels }
                            passwordRequirements={ passwordRequirements }
                            onKeyPress={ this.checkEnter } />

                        {
                            activationFields.map( ( field, index ) => {
                                const {
                                    characteristic: { code },
                                    fieldLabel
                                } = field;

                                const label = fieldLabel.find( label => label.locale.code == locale.code )
                                    && fieldLabel.find( label => label.locale.code == locale.code ).cmText || 'No Label Provided';

                                const placeholder = code === 'hiredate' ? hireDatePlaceholder :
                                                    code === 'dateofbirth' ? birthDatePlaceholder : undefined;

                                return (
                                    <div key={ code }>
                                        <label htmlFor={ code }>{ label }</label>
                                        <input
                                            type="text"
                                            name={ code }
                                            id={ code }
                                            required={ true }
                                            onChange={ this.handleField }
                                            onKeyPress={ this.checkEnter }
                                            placeholder={ placeholder }
                                        /><br/>
                                    </div>
                                );
                            } )
                        }
                    </div>

                    {
                        errors.length !== 0 && errors.map( ( error, index ) =>
                            <Alert
                                type={ 'error' }
                                onDismiss={ () => dismissError( error ) }
                                id={ `error${index}` }
                                key={ index }>
                                <p>
                                    {
                                        error.errorCode === 20003 ?
                                            <Link to="/login" style={ { color: 'white' } }>
                                                { error.responseMessage || error.message }
                                            </Link>
                                            : error.responseMessage || error.message
                                    }
                                </p>
                            </Alert>
                        )
                    }

                    <LoaderButton
                        busy={ activating }
                        onClick={ this.onActivateSubmit }
                        disabled={ this.validateFields() ? false : true }
                        done={ done }>
                        <LocaleString code="login.link.activateLabel" />
                    </LoaderButton>

                </div>
            </section>
        );
    }
}

export default Activation;
